import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Configure using environment variables in .env (REACT_APP_FIREBASE_...)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let app = null;
let auth = null;

// If critical config missing, avoid initializing Firebase (prevents invalid-api-key runtime error)
if (!firebaseConfig.apiKey) {
  // Helpful console message for developers
  // Do NOT include secrets in logs for production; this is for local dev guidance only
  // Instruct user to create SEO1/.env with required REACT_APP_FIREBASE_* values
  // Example: REACT_APP_FIREBASE_API_KEY=your_api_key_here
  // See README or Firebase console for values
  // eslint-disable-next-line no-console
  console.warn(
    'Firebase not initialized: REACT_APP_FIREBASE_API_KEY is missing. Add Firebase config to .env.'
  );
} else {
  try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Firebase initialization failed:', e);
    app = null;
    auth = null;
  }
}

export { auth };
export default app;
